<template>
	<div class="box-page">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Pengaturan</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">Pengaturan Alamat Mobile Counter</div>
					</div>
				</div>
			</div>
			<div class="col-12 pl-0 pr-0 py-4">
				<div class="col-12 pl-0 pr-0 rounded-cus bg-white overflow-hidden">
					<FormAddress :disabled="formDisabled"></FormAddress>

					<div class="col-12 pl-0 pr-0 pt-3 pb-2 d-flex justify-content-center" v-if="formDisabled">
						<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="formDisabled = false" v-if="false">
							<div class="font-size-11 text-uppercase">UBAH</div>
						</button>
					</div>
					<div class="col-12 pl-0 pr-0 pt-3 pb-2 d-flex justify-content-center" v-else>
						<button class="col-5 col-md-3 btn btn-outline-danger rounded-cus mr-4 mr-md-3" @click="batal">
							<div class="font-size-11 text-uppercase">batal</div>
						</button>
						<button class="col-6 col-md-3 btn btn-blue rounded-cus box-purple" @click="simpanAlamat">
							<div class="font-size-11 text-uppercase">simpan</div>
						</button>
					</div>
				</div>
			</div>
		</div>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<div class="modal-body pt-0 pt-md-3">
					<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center">
						<div class="col-6 col-md-5">
							<img class="img-fluid" src="/assets/modal/surprise-woman.svg">
						</div>
						<div class="col-12 col-md-7 mt-auto mb-auto pt-3 pt-md-0 text-center text-md-left">
							<div class="font-size-11 font-weight-bold">Konfirmasi Hapus</div>
							<div class="font-size-10 pt-1 pt-md-3">Apakah Anda yakin ingin menghapus Data ini?</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div class="modal-footer justify-content-center justify-content-md-end">
						<button class="col-5 col-md-3 btn btn-outline-danger d-flex justify-content-center rounded-cus" @click="hideModalAlert">
							<span class="font-size-11"><i class="fas fa-times"></i></span>
							<div class="font-size-11 pl-2">Batal</div>
						</button>
						<button class="col-5 col-md-3 btn btn-blue d-flex d-flex justify-content-center rounded-cus ml-3" @click="hapusAdmin">
							<span class="font-size-11"><i class="fas fa-check"></i></span>
							<div class="font-size-11 pl-2">Yakin</div>
						</button>
					</div>
				</div>
			</template>
		</i-modal>
	</div>
</template>

<script>
import FormAddress from '@/components/FormAddress'
import IModal from '@/components/IModal.vue';
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
	components: {
		IModal, FormAddress
	},
	data() {
		return {
			image: '',
			type : '',
			username : '',
			hak:[],
			params: {
				name : '',
				email : '',
				mobilephone : '',
				birthdate : '',
				password : '',
				privilege :'',
				is_active : 1
			},
			formDisabled: true
		}
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('commonList', ['province', 'city', 'subdistrict', 'paramsAddress']),
		...mapState('maps', ['location']),
		...mapState('profileList', ['responSukses']),
	},
	methods: {
		...mapActions('commonList', ['getCity', 'getSubdistrict']),
		...mapMutations('commonList', ['setAddressDefault']),
		...mapMutations('profileList', ['saveConfirmResponse']),
		...mapActions('profileList', ['saveAddress']),
		...mapMutations('profileList', ['clearDataProfile', 'konfirmasiSukses']),
		...mapMutations('auth', ['setProfileData']),
		...mapActions('maps', ['postGeolocation', 'getMaps']),

		simpanAlamat() {
			var params = {
				address: this.paramsAddress.address,
				province_id: this.paramsAddress.province.id,
				province_name: this.paramsAddress.province.text,
				city_id: this.paramsAddress.city.id,
				city_name: this.paramsAddress.city.text,
				subdistrict_id: this.paramsAddress.subdistrict.id,
				subdistrict_name: this.paramsAddress.subdistrict.text,
				lat: this.location.lat,
				lng: this.location.lng,
			}
			this.saveAddress(params).then(() => {
				if (this.responSukses == 200) {
					let data = Object.assign({}, this.userData)
					data['stockist_origin_province_id'] = this.paramsAddress.province.id
					data['stockist_origin_city_id'] = this.paramsAddress.city.id
					data['stockist_origin_subdistrict_id'] = this.paramsAddress.subdistrict.id
					data['stockist_origin_province_name'] = this.paramsAddress.province.text
					data['stockist_origin_city_name'] = this.paramsAddress.city.text
					data['stockist_origin_subdistrict_name'] = this.paramsAddress.subdistrict.text
					data['stockist_origin_address'] = this.paramsAddress.address
					data['stockist_latitude'] = params.lat
					data['stockist_longitude'] = params.lng
					this.setProfileData(data)
					this.formDisabled = true
					this.konfirmasiSukses('')
				}
			})
		},
		batal() {
			this.formDisabled = true
			this.setDefaultAddress()
		},
		async setDefaultAddress() {
			await this.saveConfirmResponse({})
			await this.getCity({
				province_id: this.userData.stockist_origin_province_id
			})
			await this.getSubdistrict({
				city_id: this.userData.stockist_origin_city_id
			})
			if (!this.userData.stockist_latitude && !this.userData.stockist_longitude) {
				await this.getMaps((this.userData.stockist_origin_address ? this.userData.stockist_origin_address + ', ' : '') + this.userData.stockist_origin_subdistrict_name + ', ' + this.userData.stockist_origin_city_name + ', ' + this.userData.stockist_origin_province_name)
			} else {
				let maps = await {
					lat: parseFloat(this.userData.stockist_latitude ? this.userData.stockist_latitude : 0),
					lng: parseFloat(this.userData.stockist_longitude ? this.userData.stockist_longitude : 0)
				}
				await this.postGeolocation(maps)
			}
			await this.setAddressDefault(this.userData)
		},
	},
	async created () {
		await this.setDefaultAddress()
		this.$store.dispatch('setPageTitle', 'Pengaturan Alamat');
	}
};
</script>
